import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import { useAuthStore } from '../../stores/authStore';
import { usePermStore } from '../../stores/permStore';

/**
 * Průběžně načítá oprávnění přihlášené role ze serveru (správce je může kdykoli změnit),
 * takže se menu a tlačítka přizpůsobí bez nového přihlášení. Nic nezobrazuje.
 */
export default function PermissionsLoader() {
  const userId = useAuthStore(s => s.user?.id);
  const setPerms = usePermStore(s => s.set);
  const syncUser = useAuthStore(s => s.syncUser);
  const { data } = useQuery<{ role: string | null; branchId?: string | null; permissions: string[] }>({
    queryKey: ['permissions', 'me', userId],
    queryFn: () => apiClient.get('/permissions/me').then(r => r.data.data),
    enabled: !!userId,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 15_000,
  });
  useEffect(() => {
    if (!data?.role) return;
    setPerms(data.role, data.permissions ?? []);
    syncUser(data.role, data.branchId ?? null);
  }, [data, setPerms, syncUser]);
  return null;
}
